// extracted by mini-css-extract-plugin
module.exports = {"link":"link__19Klj","left":"left__3m85x","center":"center__1CWPJ","hidden":"hidden__3TZGb"};